import { AnimatedSprite, Container, Graphics, Sprite, Texture } from 'pixi.js'
import gsap from 'gsap'
import { IItemInfo } from '@/scripts/data/types'
import { playTleskacSound } from '@/scripts/audio/soundController'

// Path is in LAYER coordinates (same parent as the sprite)
export const tleskacPath = [
  { x: 2100, y: 115, scale: 0.2 }, // start (right)
  { x: 1700, y: 110, scale: 0.5 }, // toward camera
  { x: 1100, y: -500, scale: 1 }, // recede a bit
]

export function createTleskacFromAtlas(layer: Container, def: IItemInfo) {
  const frames = [1, 2, 3, 4, 5].map((i) => Texture.from(`tleskac_${i}.png`))
  const sprite = new AnimatedSprite(frames, true)
  sprite.animationSpeed = 0.18
  sprite.play()
  sprite.anchor.set(0.5)
  sprite.zIndex = 10000
  sprite.eventMode = 'none'
  layer.addChild(sprite)

  const f0 = frames[0]
  const frameW = def.w ?? f0.orig?.width ?? f0.width
  const frameH = def.h ?? f0.orig?.height ?? f0.height
  const centerY = def.y + frameH * 0.5

  return { sprite, frameW, frameH, centerY }
}

export function animateTleskacPath(sprite: Sprite, path: { x: number; y: number; scale?: number }[]) {
  gsap.killTweensOf(sprite)

  const motionPath = path.map((p) => ({ x: p.x, y: p.y }))
  const tl = gsap.timeline({ delay: 20, repeat: -1, repeatDelay: 15 })

  tl.to(sprite, {
    duration: 15,
    motionPath: {
      path: motionPath,
      curviness: 1,
      autoRotate: false,
    },
    ease: 'linear',
    onUpdate: () => {
      const progress = tl.progress() * (path.length - 1)
      const i = Math.floor(progress)
      const next = Math.min(i + 1, path.length - 1)
      const t = progress - i
      const s1 = path[i].scale ?? 1
      const s2 = path[next].scale ?? 1
      sprite.scale.set(s1 + (s2 - s1) * t)
    },
    onStart: () => {
      sprite.visible = true
      sprite.alpha = 1
      playTleskacSound()
    },
    onRepeat: () => {
      sprite.visible = false
      sprite.alpha = 0
      sprite.position.set(path[0].x, path[0].y)
      sprite.scale.set(path[0].scale ?? 1)
      sprite.visible = true
      sprite.alpha = 1
      playTleskacSound()
    },
  })
}

export function drawDebugPath(layer: Container, path: { x: number; y: number }[]) {
  if (!path.length) return

  const g = new Graphics()
  g.zIndex = 10001

  g.lineStyle(2, 0xff0000, 0.6)
  g.moveTo(path[0].x, path[0].y)
  for (let i = 1; i < path.length; i++) g.lineTo(path[i].x, path[i].y)

  layer.addChild(g)
}
